import type { RouteConfig } from "../types";
import { adminFormRoutes } from "./form.routes";
import { adminGroupRoutes } from "./group.routes";
import { adminProcessRoutes } from "./process.routes";
import { adminSettingsRoutes } from "./settings.routes";
import { adminDashboardRoutes } from "./dashboard.routes";
import { adminManagementRoutes } from "./management.routes";
import { chatRoutes } from "./chat.routes";
import { adminTemplateRoutes } from "./template.routes";

export const adminRoutes: RouteConfig[] = [
  ...adminSettingsRoutes,
  ...adminFormRoutes,
  ...adminProcessRoutes,
  ...adminGroupRoutes,
  ...adminManagementRoutes,
  ...adminTemplateRoutes,
];
